import { UserActivityLog, UserActivityLogNode, UserActivityEntities } from '../user-activity-log.model';
import { UserActivityLogActions, UserActivityLogActionTypes } from '../actions/user-activity-log.actions';

export interface State {
  Loaded: boolean;
  Loading: boolean;
  entities: UserActivityEntities | null;
}

export const initialState: State = {
  Loaded: false,
  Loading: false,
  entities: null
};
export interface ProIncomeListState {
  Loaded: boolean;
  Loading: boolean;
  entities: any;
}

export const initialStateforProIncomeList: ProIncomeListState = {
  Loaded: false,
  Loading: false,
  entities: null
};
export interface ReportDiscountListState {
  Loaded: boolean;
  Loading: boolean;
  entities: any;
}

export const initialStateforReportDiscountList: ReportDiscountListState = {
  Loaded: false,
  Loading: false,
  entities: null
};

export function reducer(
  state = initialState,
  action: UserActivityLogActions
): State {
  switch (action.type) {

    case UserActivityLogActionTypes.GetUserActivityLogs: {
      return {...state, Loaded: false, Loading: true};
    }

    case UserActivityLogActionTypes.LoadUserActivityLogs: {
      return {...state, Loaded: true, Loading: false, entities: action.payload};
    }

    case UserActivityLogActionTypes.GetUserActivityLogsFail: {
      return {...state, Loaded: true, Loading: false, entities: action.payload};
    }

    default: {
      return state;
    }
  }
}

export function proIncomeListReducer(
  state = initialStateforProIncomeList,
  action: UserActivityLogActions
): ProIncomeListState {
  switch (action.type) {

    case UserActivityLogActionTypes.GetProIncomeList: {
      return {...state, Loaded: false, Loading: true};
    }

    case UserActivityLogActionTypes.LoadProIncomeList: {
      return {...state, Loaded: true, Loading: false, entities: action.payload};
    }

    case UserActivityLogActionTypes.GetProIncomeListFail: {
      return {...state, Loaded: true, Loading: false, entities: action.payload};
    }

    default: {
      return state;
    }
  }
}

export function reportDiscountListReducer(
  state = initialStateforReportDiscountList,
  action: UserActivityLogActions
): ReportDiscountListState {
  switch (action.type) {

    case UserActivityLogActionTypes.GetReportDiscountList: {
      return {...state, Loaded: false, Loading: true};
    }

    case UserActivityLogActionTypes.LoadReportDiscountList: {
      return {...state, Loaded: true, Loading: false, entities: action.payload};
    }

    case UserActivityLogActionTypes.GetReportDiscountListFail: {
      return {...state, Loaded: true, Loading: false, entities: action.payload};
    }

    default: {
      return state;
    }
  }
}

export const getProIncomeListState = (state: ProIncomeListState) => state;
export const getReportDiscountListState = (state: ReportDiscountListState) => state;
